import React, { useEffect, useState } from 'react';

/**
 * Drop-in replacement for react-toasts ToastContainer.
 * Uses the same CSS classes (.react-toasts-container, .react-toasts.<status>)
 * so existing styles continue to apply, but has no react-transition-group
 * dependency and therefore no React 19 legacy-context warnings.
 */
export default function AppToastContainer({ store, style: position = 'top right' }) {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const subscription = store.watch((data) => {
      const id = Math.random();
      setToasts((prev) => [...prev, { ...data, id }]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, data.timer || 3000);
    });
    return () => store.unwatch(subscription);
  }, [store]);

  const positionStyles = {
    'top right':    { top: 10, right: 10 },
    'top left':     { top: 10, left: 10 },
    'bottom right': { bottom: 10, right: 10 },
    'bottom left':  { bottom: 10, left: 10 },
  };
  const containerStyle = positionStyles[position] || positionStyles['top right'];

  return (
    <div className="react-toasts-container" style={containerStyle}>
      {toasts.map((toast) => (
        <div key={toast.id} className={`react-toasts ${toast.status}`}>
          {toast.message}
        </div>
      ))}
    </div>
  );
}
